export function getFacetOptionsSliceInitialState() {
    return { enabled: true, tabs: {} };
}
export function getFacetOptionsInitialState() {
    return {
        freezeFacetOrder: false,
        facets: {},
    };
}
